export const SEARCH_BY_FIELDS = [
  {
    text: 'ID',
    value: 'id',
  },
  {
    text: 'Email',
    value: 'email',
  },
  {
    text: 'Номер телефону',
    value: 'phone',
  },
  {
    text: "Ім'я",
    value: 'firstName',
  },
  {
    text: 'Прізвище',
    value: 'lastName',
  },
  {
    text: 'Дата народження',
    value: 'birthDate',
  },
  {
    text: 'Номер рахунку',
    value: 'bankAccountNumber',
  },
  {
    text: 'Pesel',
    value: 'pesel',
  },
  {
    text: 'Номер паспорта',
    value: 'passportId',
  },
];

export const TABLE_HEADERS = [
  {
    text: 'ID',
    value: 'id',
  },
  {
    text: 'Email',
    value: 'email',
  },
  {
    text: 'Номер телефону',
    value: 'phone',
  },
  {
    text: "Ім'я",
    value: 'firstName',
  },
  {
    text: 'Прізвище',
    value: 'lastName',
  },
  {
    text: 'Номер рахунку',
    value: 'bankAccountNumber',
  },
  {
    text: 'Способ выплаты',
    value: 'payoutType',
  },
  {
    text: 'Umowa zlecenia',
    value: 'isMandateContract',
  },
  {
    text: 'Umowa zlecenia Тип',
    value: 'mandateContractType',
  },
  {
    text: 'Etat',
    value: 'mandateContractTime',
  },
  {
    text: 'Предпочитаемые Приложения',
    value: 'preferredApplications',
  },
  {
    text: 'Тарифы',
    value: 'tariffs',
    width: 230,
  },
  {
    text: 'UberId',
    value: 'uberId',
    width: 300,
  },
  {
    text: 'BoltId',
    value: 'boltId',
    width: 300,
  },
  {
    text: 'FreeNowId',
    value: 'freeNowId',
  },
  {
    text: 'UberEatsId',
    value: 'uberEatsId',
    width: 300,
  },
  {
    text: 'BoltFoodId',
    value: 'boltFoodId',
  },
  {
    text: 'GlovoId',
    value: 'glovoId',
  },
  {
    text: 'StuardId',
    value: 'stuartId',
  },
  {
    text: 'WoltId',
    value: 'woltId',
  },
  {
    text: 'Номерний знак',
    value: 'vehicleRegistration',
  },
];

export const getTextAreasWithSave = () => [
  {
    name: 'Информация',
    type: 'info',
    dispatchType: 'chat/set_info',
    commitType: 'chat/SET_INFO_V2',
    placeholder: 'Информацию впишите сюда...',
  },
  {
    name: 'Заметка',
    type: 'additionalInfo',
    dispatchType: 'chat/set_additional_info',
    commitType: 'chat/SET_ADDITIONAL_INFO_V2',
    placeholder: 'Заметку впишите сюда...',
  },
];

export const CHAT_TAG = {
  BAILIFF: 'bailiff',
  CASH: 'cash',
  LETBE: 'letbe',
  LITLEO: 'litleo',
  VAT_AGREEMENT: 'vatAgreement',
  PRONTO_TAXI: 'prontoTaxi',
};

export const TAG_OPTIONS = [
  { label: 'Коморник', value: CHAT_TAG.BAILIFF },
  { label: 'Выплата наличными', value: CHAT_TAG.CASH },
  { label: 'LetBe', value: CHAT_TAG.LETBE },
  { label: 'LitLeo', value: CHAT_TAG.LITLEO },
  { label: 'Договор VAT', value: CHAT_TAG.VAT_AGREEMENT },
  { label: 'Pronto Taxi', value: CHAT_TAG.PRONTO_TAXI },
];
